import { useState, useEffect } from 'preact/hooks';
import { authenticatedFetch } from '../../services/authService.js';

/**
 * Banner for existing demo users to opt-in to product tips.
 * Shown when marketing_email_consent is null (not yet asked).
 * Dismissed permanently after any choice.
 */
export default function NurtureConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    checkConsentStatus();
  }, []);

  async function checkConsentStatus() {
    try {
      const res = await authenticatedFetch('/api/v1/users/me');
      if (!res.ok) return;
      const userData = await res.json();

      // Show banner only if:
      // 1. marketing_email_consent is null (not asked yet)
      // 2. User has active demo subscription
      if (
        userData.marketing_email_consent === null &&
        userData.subscription?.tier === 'DEMO' &&
        userData.subscription?.status === 'ACTIVE'
      ) {
        setVisible(true);
      }
    } catch {
      // Silently fail - banner is non-critical
    }
  }

  async function handleChoice(consent) {
    setSaving(true);
    try {
      await authenticatedFetch('/api/v1/users/me/email-preferences', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ marketing_email_consent: consent }),
      });
    } catch {
      // Silently fail
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="nurture-consent-banner">
      <div className="nurture-consent-banner__content">
        <span className="nurture-consent-banner__text">
          Want helpful tips and real-world use cases to get the most out of your demo?
        </span>
        <div className="nurture-consent-banner__actions">
          <button
            className="nurture-consent-banner__btn nurture-consent-banner__btn--accept"
            onClick={() => handleChoice(true)}
            disabled={saving}
          >
            Yes, send me tips
          </button>
          <button
            className="nurture-consent-banner__btn nurture-consent-banner__btn--decline"
            onClick={() => handleChoice(false)}
            disabled={saving}
          >
            No thanks
          </button>
        </div>
      </div>
    </div>
  );
}
